module.exports = __webpack_public_path__ + "img/T20.b7bd4a1e.jpg";